import Icon from '../components/Icon.vue'

Icon.register({"database":{"width":448,"height":512,"paths":[{"d":"M448 73.1V118.9C448 159.1 347.7 192 224 192S0 159.1 0 118.9V73.1C0 32.9 100.3 0 224 0S448 32.9 448 73.1zM448 176V278.9C448 319.1 347.7 352 224 352S0 319.1 0 278.9V176C48.1 209.1 136.2 224.6 224 224.6S399.9 209.1 448 176zM448 336V438.9C448 479.1 347.7 512 224 512S0 479.1 0 438.9V336C48.1 369.1 136.2 384.6 224 384.6S399.9 369.1 448 336z"}]}})



//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-awesome@3.0.0@vue-awesome/icons/database.js
// module id = null
// module chunks = 